import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex-node-col" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "greenText" }
const _hoisted_4 = {
  class: "fw text-center",
  style: {"margin-top":"30px"}
}
const _hoisted_5 = {
  key: 1,
  class: "flex-node-col text-left"
}
const _hoisted_6 = { style: {"margin-left":"var(--shadow-clearance)"} }
const _hoisted_7 = { class: "checkout-cards-row" }
const _hoisted_8 = { class: "flex-container-row gap5 delivery-field" }
const _hoisted_9 = { class: "flex-container-row gap5 delivery-field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_icon = _resolveComponent("my-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_card_title = _resolveComponent("card-title")!
  const _component_card_header = _resolveComponent("card-header")!
  const _component_address_selector = _resolveComponent("address-selector")!
  const _component_input_field = _resolveComponent("input-field")!
  const _component_country_selector = _resolveComponent("country-selector")!
  const _component_card_body = _resolveComponent("card-body")!
  const _component_card = _resolveComponent("card")!
  const _component_k_button = _resolveComponent("k-button")!
  const _component_input_form = _resolveComponent("input-form")!
  const _component_loader_guard = _resolveComponent("loader-guard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_loader_guard, {
      "has-loaded": _ctx.hasLoaded && !_ctx.isCommitting
    }, {
      default: _withCtx(() => [
        (_ctx.showCommitSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h2", _hoisted_3, [
                _createVNode(_component_my_icon, {
                  icon: "check",
                  color: "green"
                }),
                _createTextVNode("  " + _toDisplayString(_ctx.localize('shoppingCartCommitSuccess')), 1)
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, { to: { name: 'partner'} }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.localize('back')), 1)
                  ]),
                  _: 1
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.localize('submitOrder')), 1),
              _createVNode(_component_input_form, {
                "submit-text": _ctx.localize('submitOrder'),
                "submit-action": _ctx.onCommitOrder
              }, {
                buttons: _withCtx(() => [
                  _createVNode(_component_k_button, {
                    icon: "arrow-left",
                    onClick: _ctx.onBack
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.localize(_ctx.isSmallScreen ? 'back' : 'backToShoppingCart')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_card, { class: "order-section" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card_header, { class: "k-hstack section" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.localize('deliveryAddress')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_card_body, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_address_selector, {
                              id: "addresses",
                              "onUpdate:modelValue": _ctx.onSelectedAddress,
                              class: "delivery-field"
                            }, null, 8, ["onUpdate:modelValue"]),
                            _createVNode(_component_input_field, {
                              id: "name1",
                              modelValue: _ctx.orderData.deliveryAddress.name1,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.orderData.deliveryAddress.name1) = $event)),
                              required: true,
                              label: _ctx.localize('name'),
                              placeholder: _ctx.localize('enterName'),
                              class: "delivery-field"
                            }, null, 8, ["modelValue", "label", "placeholder"]),
                            _createVNode(_component_input_field, {
                              id: "name2",
                              modelValue: _ctx.orderData.deliveryAddress.name2,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.orderData.deliveryAddress.name2) = $event)),
                              label: _ctx.localize('name2'),
                              placeholder: _ctx.localize('enterName2'),
                              class: "delivery-field"
                            }, null, 8, ["modelValue", "label", "placeholder"]),
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_input_field, {
                                id: "streetName",
                                modelValue: _ctx.orderData.deliveryAddress.streetName,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.orderData.deliveryAddress.streetName) = $event)),
                                required: true,
                                label: _ctx.localize('streetName'),
                                placeholder: _ctx.localize('enterStreetName'),
                                style: {"width":"75%"}
                              }, null, 8, ["modelValue", "label", "placeholder"]),
                              _createVNode(_component_input_field, {
                                id: "houseNumber",
                                modelValue: _ctx.orderData.deliveryAddress.houseNumber,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.orderData.deliveryAddress.houseNumber) = $event)),
                                label: _ctx.localize('houseNumber'),
                                placeholder: _ctx.localize('enterHouseNumber'),
                                style: {"width":"25%"}
                              }, null, 8, ["modelValue", "label", "placeholder"])
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_component_input_field, {
                                id: "zipCode",
                                modelValue: _ctx.orderData.deliveryAddress.zipCode,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.orderData.deliveryAddress.zipCode) = $event)),
                                required: true,
                                label: _ctx.localize('zipCode'),
                                placeholder: _ctx.localize('enterZipCode'),
                                style: {"width":"20%"}
                              }, null, 8, ["modelValue", "label", "placeholder"]),
                              _createVNode(_component_input_field, {
                                id: "city",
                                modelValue: _ctx.orderData.deliveryAddress.cityName,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.orderData.deliveryAddress.cityName) = $event)),
                                required: true,
                                label: _ctx.localize('city'),
                                placeholder: _ctx.localize('enterCity'),
                                style: {"width":"80%"}
                              }, null, 8, ["modelValue", "label", "placeholder"])
                            ]),
                            _createVNode(_component_country_selector, {
                              id: "countryCode",
                              modelValue: _ctx.orderData.deliveryAddress.countryCode,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.orderData.deliveryAddress.countryCode) = $event)),
                              class: "delivery-field"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_input_field, {
                              id: "attention",
                              modelValue: _ctx.orderData.deliveryAddress.attention,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.orderData.deliveryAddress.attention) = $event)),
                              label: _ctx.localize('attention'),
                              placeholder: _ctx.localize('enterAttention'),
                              class: "delivery-field"
                            }, null, 8, ["modelValue", "label", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_card, { class: "order-section" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card_header, { class: "k-hstack section" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_card_title, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.localize('orderData')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_card_body, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize('orderCommentLabel')) + " ", 1),
                            _createVNode(_component_input_field, {
                              id: "comment",
                              modelValue: _ctx.orderData.comment,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.orderData.comment) = $event)),
                              label: _ctx.localize('comment'),
                              placeholder: _ctx.localize('enterComment'),
                              height: 150,
                              class: "delivery-field"
                            }, null, 8, ["modelValue", "label", "placeholder"]),
                            _createVNode(_component_input_field, {
                              id: "reference",
                              modelValue: _ctx.orderData.reference,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.orderData.reference) = $event)),
                              required: true,
                              label: _ctx.localize('reference'),
                              placeholder: _ctx.localize('enterReference'),
                              class: "delivery-field"
                            }, null, 8, ["modelValue", "label", "placeholder"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["submit-text", "submit-action"])
            ]))
      ]),
      _: 1
    }, 8, ["has-loaded"])
  ]))
}